// extracted by mini-css-extract-plugin
export const footerBanner = "footer-module--footerBanner--1TLKG";
export const footerBannerContent = "footer-module--footerBannerContent--3RbMS";
export const fbFlex = "footer-module--fbFlex--eCnb0";
export const downloadLinks = "footer-module--downloadLinks--2W9GN";
export const appStore = "footer-module--appStore--1A_7m";
export const goolePlayStore = "footer-module--goolePlayStore--3BW7h";
export const footerBannerLogo = "footer-module--footerBannerLogo--vCKAX";
export const footer = "footer-module--footer--2-hg1";
export const footerMenu = "footer-module--footerMenu--1OHnJ";
export const row = "footer-module--row--1ESGn";
export const col = "footer-module--col--3EW8G";
export const footerMenuItem = "footer-module--footerMenuItem--1z7Ja";
export const socialMediaFooter = "footer-module--socialMediaFooter--2NNKq";
export const bottomFooterMenu = "footer-module--bottomFooterMenu--SpOij";
export const footerText = "footer-module--footerText--3vhoB";